<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="result-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="notice">                        
                        仅可退队1次，确认退出本次队伍吗？
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="quit()"></div>                                                                 
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.result-modal{
    position: relative;
    width: 650px;
    height: 404px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);
 
}

.title{
    width: 255px;
    height: 39px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/modal/title-quit.png);
}

.notice{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
    text-align: center;
    color: #daefff;
    font-size: 20px;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 30px;
    padding: 0 20px;
}

.u-btn.ok{
    width: 279px;
    height: 87px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 279px;
    height: 87px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiQuit, } from '@/api/index';
export default {
    data () {
        return {
            visible : false,
            text : '',
            isSSr : false,
            item : {},
            basket : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy();
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        quit(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            apiQuit().then(
                res => {
                    //this.$toast('领取成功');
                    this.destroyElement();
                    this.$team_update();
                    this.$msg_modal({type : 'success' , text : '成功退出小队'});
                },
                rej => {
                    this.$toast(rej.message);
                },                
            )
        },               
    },    
}
</script>